import { createApp } from 'vue'
import App from './App.vue'
import './index.css'
import router from './router/index'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import TlbsMap from 'tlbs-map-vue'

window.addEventListener('unhandledrejection', event => {
  if (event.reason && event.reason.__handled) {
    event.preventDefault()
  }
})

const language = 'cn'

const app = createApp(App)

app.use(router)
app.use(ElementPlus, { locale: language == 'cn' ? zhCn : en })
app.use(TlbsMap)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.mount('#app')